import styles from './quickReads.scss';

export const QuickReads = ({ SECTION_QUICKREADS }) => (
  <div className="lil-bg-black-100 lil-my-24">
    <div className="lil-container lil-py-16">
      <h2 className="lil-py-2 lil-text-s-56 sm:lil-text-s-32 lil-text-white lil-mb-10 sm:lil-mb-2">
        Quick reads
      </h2>

      <div className="lil-flex lil-flex-wrap sm:lil-flex-col">
        {SECTION_QUICKREADS.map((ele, index) => {
          return (
            <div
              key={index}
              className={`lil-pr-10 lil-w-1/3 sm:lil-w-full lil-mt-10 lil-cursor-pointer sm:lil-pr-0`}
            >
              <a href={ele.link} className="hover:lil-no-underline">
                <div
                  className={`lil-bg-black-50 lil-p-8 lil-rounded-xl ${styles['cardQuicRead']}`}
                >
                  <img src={ele.icon} className="lil-h-12 lil-mb-2"></img>
                  <h6 className="lil-mb-2 lil-text-s-24 lil-text-white">
                    {ele.title}
                  </h6>
                  <p>
                    {ele.description.slice(0, 230)}... {'  '}
                    <span className="lil-cursor-pointer lil-text-blue-350 lil-text-s-14 lil-font-semibold">
                      Read more
                    </span>
                  </p>

                  {/* <p>{ele.title}</p> */}
                </div>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/quickReadSection/quickReads.tsx